export const mutations = {
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/module/signIn/mutations.js